<script setup lang="ts">
withDefaults(
  defineProps<{
    count: number
    ariaLabel?: string
    complete?: boolean
  }>(),
  {
    ariaLabel: undefined,
    complete: false,
  },
)
</script>

<template>
  <span
    v-if="count > 0"
    class="border-warning/20 bg-warning-subtle text-warning inline-flex min-w-4 items-center justify-center rounded-full border px-1.5 py-0.5 text-center text-[11px] leading-none font-bold tabular-nums"
    :aria-label="ariaLabel"
    :aria-hidden="ariaLabel ? undefined : true">
    {{ count }}
  </span>

  <span
    v-else-if="complete"
    class="bg-success-subtle text-success inline-flex size-4 items-center justify-center rounded-full"
    :aria-label="ariaLabel"
    :aria-hidden="ariaLabel ? undefined : true">
    <i class="pi pi-check text-[9px]!" aria-hidden="true" />
  </span>
</template>
